import { useAppDispatch } from 'shared/lib/redux';
import { useSetWalkthroughStatusMutation } from 'shared/api/client-state';
import { AuthService } from 'shared/lib/keycloak';

import { finishWalkthrough } from '../model';

import { useWalkthroughStatus } from './use-walkthrough-status';

export const useWalkthroughCompletion = () => {
  const dispatch = useAppDispatch();
  const userBk = AuthService.getUserBk();

  const [setWalkthroughStatus] = useSetWalkthroughStatusMutation();
  const isWalkthroughCompleted = useWalkthroughStatus();

  return () => {
    // Avoid sending extra request if the walkthrough has already completed.
    if (!isWalkthroughCompleted) {
      setWalkthroughStatus({
        userBk,
        walkthroughStatus: {
          isWalkthroughCompleted: true,
        },
      });
    }

    dispatch(finishWalkthrough());
  };
};
